$(() => {
    const jointAgentModal = $('#joint-agent-modal');
    const jointAgent = $('input#_joint-agent').val() || '';

    if (jointAgent) {
        jointAgentModal.modal({ show: true });
    }
})
